const ReverseElementScroll = (ref:HTMLElement) => {
    if(ref){
        ref.addEventListener('wheel', (event) => {
            event.preventDefault();
            const reversedDeltaY = -event.deltaY;
            const reversedDeltaX = -event.deltaX;

            reversedScrollTo(ref,reversedDeltaX, reversedDeltaY);
        });
        ref.style.overflow = 'hidden';
    }
}

const reversedScrollTo = (element: HTMLElement, deltaX: number, deltaY: number) =>{
    element.scrollLeft +=  deltaX;
    element.scrollTop +=  deltaY;
}

export default ReverseElementScroll

